module.exports = __webpack_public_path__ + "img/tu2.45317eb1.jpg";